import { render, staticRenderFns } from "./summernote.vue?vue&type=template&id=07a6eeac"
import script from "./summernote.vue?vue&type=script&lang=js"
export * from "./summernote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a6eeac')) {
      api.createRecord('07a6eeac', component.options)
    } else {
      api.reload('07a6eeac', component.options)
    }
    module.hot.accept("./summernote.vue?vue&type=template&id=07a6eeac", function () {
      api.rerender('07a6eeac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/admin/partials/summernote.vue"
export default component.exports